import { watchEffect } from "vue"
import { DEFAULT_SCOPE_NAME } from "@core/constants"
import { useConfigStore } from "@core/stores/config.store"

/** Favicon statique servi par défaut (voir `index.html`). */
const DEFAULT_FAVICON_HREF = "/favicon_homeys.png"

function guessIconType(href: string): string {
    const lower = href.split("?")[0]?.toLowerCase() ?? ""
    if (lower.endsWith(".ico")) return "image/x-icon"
    if (lower.endsWith(".svg")) return "image/svg+xml"
    if (lower.endsWith(".webp")) return "image/webp"
    if (lower.endsWith(".gif")) return "image/gif"
    return "image/png"
}

/**
 * Met à jour la balise `link[rel="icon"]` : favicon du scope (`assets.logos.favicon`)
 * si le scope n’est pas {@link DEFAULT_SCOPE_NAME}, sinon favicon Homeys par défaut.
 */
function applyFaviconHref(href: string) {
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
    if (!link) {
        link = document.createElement("link")
        link.rel = "icon"
        document.head.appendChild(link)
    }
    link.href = href
    link.type = guessIconType(href)
}

/**
 * Synchronise le favicon du navigateur avec le scope courant (après chargement du store config).
 */
export function useScopeFavicon() {
    const configStore = useConfigStore()

    watchEffect(() => {
        const scope = configStore.scope
        const name = scope?.name
        const faviconUrl = scope?.assets?.logos?.favicon?.trim()

        if (name && name !== DEFAULT_SCOPE_NAME && faviconUrl) {
            applyFaviconHref(faviconUrl)
        } else {
            applyFaviconHref(DEFAULT_FAVICON_HREF)
        }
    })
}
